module.exports = __webpack_public_path__ + "static/media/pdf-download.dca2cb6d.png";